import Navbar from "@/components/unsf/Navbar"
import Hero from "@/components/unsf/Hero"
import NewIn from "@/components/unsf/NewIn"
import BrowseProducts from "@/components/unsf/BrowseProducts"
import HandmadeSection from "@/components/unsf/HandmadeSection"
import Footer from "@/components/unsf/Footer"
import UnsfHead, { UnsfMeta } from "@/components/unsf/UnsfHead"
import type { UnsfItem } from "@/components/unsf/ProductCard"

interface HomeProps {
  meta: UnsfMeta
  hero: {
    background_image: string
    title: string
    subtitle?: string
    alt_text?: string
    cta_label: string
    cta_url: string
  }
  new_in: { title: string; items: UnsfItem[] }
  browse: {
    title: string
    view_all_label: string
    view_all_url: string
    items: UnsfItem[]
  }
  handmade: {
    image: string
    title: string
    blocks: Array<{ title: string; text: string }>
  }
  navbar: {
    logo_white: string
    logo_black: string
    labels: { store: string; about: string; cart: string }
    urls: { root: string; store: string; about: string }
    locale: { current: string; other: string; switch_url: string }
  }
  footer: {
    logo_white: string
    labels: {
      brand: string
      about_us: string
      contact: string
      help_legal: string
      returns: string
      privacy: string
      terms: string
      socials: string
    }
    urls: {
      about: string
      contact: string
      returns: string
      confidentiality: string
      cgv: string
      instagram: string
    }
  }
  i18n: {
    soldout: string
    last_pieces: string
    no_image: string
    pre_sale: string
  }
  csrf_token: string
  cart: import("@/components/unsf/Cart").CartData
}

export default function Home({
  meta,
  hero,
  new_in,
  browse,
  handmade,
  navbar,
  footer,
  i18n,
  cart,
  csrf_token,
}: HomeProps) {
  return (
    <>
      <UnsfHead meta={meta} />

      <Navbar
        isHome
        logoWhite={navbar.logo_white}
        logoBlack={navbar.logo_black}
        labels={navbar.labels}
        urls={navbar.urls}
        locale={{
          current: navbar.locale.current,
          other: navbar.locale.other,
          switchUrl: navbar.locale.switch_url,
        }}
        csrfToken={csrf_token}
        cart={cart}
      />

      <Hero
        backgroundImage={hero.background_image}
        title={hero.title}
        subtitle={hero.subtitle}
        altText={hero.alt_text}
        ctaLabel={hero.cta_label}
        ctaUrl={hero.cta_url}
      />

      <NewIn title={new_in.title} items={new_in.items} i18n={i18n} />

      <BrowseProducts
        title={browse.title}
        viewAllLabel={browse.view_all_label}
        viewAllUrl={browse.view_all_url}
        items={browse.items}
        i18n={i18n}
      />

      <HandmadeSection
        image={handmade.image}
        title={handmade.title}
        blocks={handmade.blocks}
      />

      <Footer
        logoWhite={footer.logo_white}
        labels={footer.labels}
        urls={footer.urls}
      />
    </>
  )
}
